import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastType } from '@maced/angular-components/lib/toast/toast.model';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {
  showToast: boolean = false;
  type: ToastType = 'success';
  typeList: ToastType[] = ['success', 'warning', 'error', 'info'];
  hasCloseButton = true;
  message = 'Test';
  ariaLabel = 'Close';
  currentUrl: string = "";
  hasDefinedIcon = false;
  hasModifiedIcon = true;
  modifiedIcon = 'icon-add-to-favourite' as string;
  link: { label: string, hyperLink: string } = { label: 'Action', hyperLink: '/button' };

  constructor(private _activatedRoute: ActivatedRoute, private router: Router) {
    this.currentUrl = this.router.url.split('?')[0];
  }

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe(param => {
      if (param.toastId) {
        this.showToast = (param.isOpen === "true");
      }
    });
  }
}